import { createApiClient, createRememberStorage } from "@studyward/shared";
import { createClient } from "@supabase/supabase-js";
import { apiBaseUrl, env, isConfigured } from "./env";

export const authStorage = createRememberStorage("sw-admin");

/**
 * Admin's own Supabase client. Sessions are stored per origin, so a student session on the web app never reaches
 * the admin host (§4.4). Admins sign in with email + password + TOTP only — no social sign-in here (§8.1).
 */
export const supabase = createClient(isConfigured ? env.supabaseUrl : "http://localhost:54321", isConfigured ? env.supabaseAnonKey : "unset", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: authStorage.storage,
    storageKey: "sw-admin-auth",
  },
});

export const api = createApiClient({
  baseUrl: apiBaseUrl,
  apiKey: env.supabaseAnonKey,
  getAccessToken: async () => (await supabase.auth.getSession()).data.session?.access_token ?? null,
});
